import { render, staticRenderFns } from "./createSocio2.vue?vue&type=template&id=8e5048a8&scoped=true&"
import script from "./createSocio2.vue?vue&type=script&lang=js&"
export * from "./createSocio2.vue?vue&type=script&lang=js&"
import style0 from "./createSocio2.vue?vue&type=style&index=0&id=8e5048a8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8e5048a8",
  null
  
)

export default component.exports